const NestedApp = () => {
  return <div>Nested</div>;
};

export default NestedApp;
